import {useService} from '@cindedi/react-application';
import type {MetaFunction, LoaderFunction} from '@remix-run/node';
import {json} from '@remix-run/node';
import {Link, useLoaderData} from '@remix-run/react';
import {PublicLayout} from '~/domains/organization/components/PublicLayout';
import {seoMeta} from '~/domains/organization/utilities/seoMeta';

export interface LinksPageLoaderData {
  links: Organization.PublicLinkDto[];
}

export const meta: MetaFunction = function LinksPageMeta({matches}) {
  return seoMeta('links', {title: 'Links - Cindedi', description: 'Acesse links úteis sobre o CINDEDI e a USP. Encontre informações importantes e conecte-se com nossas iniciativas de pesquisa!'}, matches);
};

export const loader: LoaderFunction = async function LinksPageLoader({context: {use}}) {
  const links = await use('Link').all();

  return json({
    links: links.sortBy('name').all(),
  });
};

export default function LinksPageView() {
  const data = useLoaderData<LinksPageLoaderData>();
  useService('organization/titlebar').setTitle('Links');

  return (
    <PublicLayout>
      <ul className="flex flex-col gap-2">
        {data.links.map((link) => (
          <li key={link.id} className="hover:bg-shade-3 bg-shade-2 rounded p-2">
            <Link target="_blank" key={link.id} to={link.url}>
              <div className="flex flex-col">
                <span className="font-semibold text-primary-12">{link.name}</span>
                <div className="flex gap-2 text-shade-11 text-sm items-center mt-1">{link.url}</div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </PublicLayout>
  );
}
